import { render, staticRenderFns } from "./SLAs.vue?vue&type=template&id=1f7fdf8b&scoped=true&"
import script from "./SLAs.vue?vue&type=script&lang=js&"
export * from "./SLAs.vue?vue&type=script&lang=js&"
import style0 from "./SLAs.vue?vue&type=style&index=0&id=1f7fdf8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7fdf8b",
  null
  
)

export default component.exports